export const GET_PANEL_CONTROL_CONFIG = 'GET_PANEL_CONTROL_CONFIG';
export const GET_PANEL_CONTROL_CONFIG_LOADING = 'GET_PANEL_CONTROL_CONFIG_LOADING';
export const GET_PANEL_CONTROL_CONFIG_ERROR = 'GET_PANEL_CONTROL_CONFIG_ERROR';
